// extracted by mini-css-extract-plugin
export var activeFilterButton = "_jp-c";
export var backButton = "_jp-4";
export var backIcon = "_jp-5";
export var chevronShortcut = "_jp-6";
export var container = "_jp-1";
export var editor = "_jp-8";
export var editorWrapper = "_jp-7";
export var prefix = "_jp-2";
export var searchIcon = "_jp-3";
export var suffix = "_jp-9";
export var suffixContent = "_jp-a";
export var suffixText = "_jp-b";
export var wrapper = "_jp-0";